<div class="auth-page">
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-header">
        <app-logo />
      </div>

      <form class="auth-form" [formGroup]="formModel.form" (ngSubmit)="submitForm()">
        <div>
          <label for="current-pwd-input" class="sr-only">{{ "INPUTS.CURRENT_PASSWORD" | translate }}</label>

          @let currentPasswordFormControl = formModel.form.controls.currentPassword;
          <input
            id="current-pwd-input"
            type="password"
            class="input-field-lg w-full"
            [placeholder]="'INPUTS.CURRENT_PASSWORD' | translate"
            [class.is-invalid]="
              (currentPasswordFormControl.touched || currentPasswordFormControl.dirty) &&
              currentPasswordFormControl.errors
            "
            [class.is-valid]="!currentPasswordFormControl.errors"
            [formControlName]="formModel.fieldNames.currentPassword"
          />
          <ng-container
            *ngTemplateOutlet="
              validationErrorsTemplate;
              context: { errors: currentPasswordFormControl.errors }
            "
          ></ng-container>
        </div>

        <div>
          <label for="new-pwd-input" class="sr-only">{{ "INPUTS.NEW_PASSWORD" | translate }}</label>

          @let newPasswordFormControl = formModel.form.controls.newPassword;
          <input
            id="new-pwd-input"
            type="password"
            class="input-field-lg w-full"
            [placeholder]="'INPUTS.NEW_PASSWORD' | translate"
            [class.is-invalid]="
              (newPasswordFormControl.touched || newPasswordFormControl.dirty) &&
              newPasswordFormControl.errors
            "
            [class.is-valid]="!newPasswordFormControl.errors"
            [formControlName]="formModel.fieldNames.newPassword"
          />
          <ng-container
            *ngTemplateOutlet="
              validationErrorsTemplate;
              context: { errors: newPasswordFormControl.errors }
            "
          ></ng-container>
        </div>

        <div>
          <label for="repeat-pwd-input" class="sr-only">{{ "INPUTS.REPEAT_PASSWORD" | translate }}</label>

          @let confirmPasswordFormControl = formModel.form.controls.confirmPassword;
          <input
            id="repeat-pwd-input"
            type="password"
            class="input-field-lg w-full"
            [placeholder]="'INPUTS.REPEAT_PASSWORD' | translate"
            [class.is-invalid]="
              (confirmPasswordFormControl.touched || confirmPasswordFormControl.dirty) &&
              confirmPasswordFormControl.errors
            "
            [class.is-valid]="!confirmPasswordFormControl.errors"
            [formControlName]="formModel.fieldNames.confirmPassword"
          />
          <ng-container
            *ngTemplateOutlet="
              validationErrorsTemplate;
              context: { errors: confirmPasswordFormControl.errors }
            "
          ></ng-container>
        </div>

        <button
          type="submit"
          class="btn-primary auth-submit w-full rounded-xl"
          [disabled]="formModel.form.invalid"
        >
          {{ "BUTTONS.CHANGE_PASSWORD" | translate }}
        </button>
      </form>
    </div>
  </div>
</div>

<ng-template #validationErrorsTemplate let-errors="errors">
  <ul class="invalid-feedback mt-2" *ngIf="errors">
    <li *ngIf="errors['required']">{{ "ERRORS.REQUIRED" | translate }}</li>
    <li *ngIf="errors['email']">{{ "ERRORS.EMAIL" | translate }}</li>
    <li *ngIf="errors['minlength']">
      {{
        "ERRORS.MINLENGTH"
          | translate: { requiredLength: errors["minlength"].requiredLength }
      }}
    </li>
    <li *ngIf="errors['maxlength']">
      {{
        "ERRORS.MAXLENGTH"
          | translate: { requiredLength: errors["maxlength"].requiredLength }
      }}
    </li>
    <li *ngIf="errors['hasDigit']">{{ "ERRORS.HAS_DIGIT" | translate }}</li>
    <li *ngIf="errors['hasLowerCase']">{{ "ERRORS.HAS_LOWERCASE" | translate }}</li>
    <li *ngIf="errors['hasUpperCase']">{{ "ERRORS.HAS_UPPERCASE" | translate }}</li>
    <li *ngIf="errors['passwordsNotEqual']">{{ "ERRORS.PASSWORDS_NOT_MATCH" | translate }}</li>
  </ul>
</ng-template>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>

<ng-template #successTpl>
  {{ message }}
</ng-template>
